<template>
  <div class="home-header">
    <div class="home-logo">
      <img src="../../../assets/images/logo.png" />
    </div>
    <div class="home-header-balance">
      <div class="left">
        <img src="../../../assets/images/222.png" />
      </div>

      <div class="center">
        <div class="balance">{{ safeUsr.balance }}</div>
        <van-icon name="arrow-down" style="display: none;" />
      </div>
      <div class="right">
        <img src="../../../assets/images/push.png" @click="safeboxshow=true" />
      </div>
    </div>
    <div class="header-menu">
      <div class="item" @click="$router.push({ name: 'mine'});">
        <img
          class="headimg"
          :src="safeUsr.avatar && safeUsr.avatar.length > 0 ? safeUsr.avatar: require('../../../assets/images/headericon/headimg.png')"
        />
      </div>
      <div class="item" @click="$router.push({ name: 'news' })">
        <van-badge :content="noticeNum" :max="99" v-if="noticeNum > 0">
          <img src="../../../assets/images/headericon/notice.png" />
        </van-badge>
        <img v-else src="../../../assets/images/headericon/notice.png" />
      </div>
      <div class="item" @click="toShowUsrMenu">
        <img src="../../../assets/images/headericon/menu.png" />
      </div>
    </div>
    <div class="safe-box">
      <van-popup v-model="safeboxshow" v-if="safeboxshow" closeable round>
        <SafeBox ref="safe" @closep2="closep2" :usr="safeUsr" />
      </van-popup>
    </div>
  </div>
</template>

<script>
import SafeBox from '@/components/SafeBox/index.vue'
export default {
  name: 'HomeHeaderView',
  components: { SafeBox },
  props:['usr'],
  computed:{
    safeUsr() {
      return this.usr || {}
    }
  },
  data () {
    return {
      balance: 0,
      noticeNum: 0,
      // usr:{},
      safeboxshow:false
    }
  },
  mounted () {
    // this.getusrInf()
    this.getNotice()
  },
  methods: {
    closep2 () {
      this.safeboxshow = false
      this.$nextTick(()=>{
      this.$emit('usrInf')
      })
    },
    async getusrInf () {
      await this.$http({
        method: 'post',
        url: 'usrInf'
      }).then(data => {
        this.safeUsr = data.data
        this.balance = data.data.balance
      })
    },
    async getBalance () {
      await this.$http({
        method: 'post',
        url: 'getbalance'
      }).then(data => {
        this.balance = data.data.balance
      })
    },
    async getNotice () {
      await this.$http({
        method: 'post',
        url: 'usrnotice',
        data: { page: 1, limit: 99999 }
      }).then(data => {
        const tmp = data.data.data.filter(e => e.is_read != 1)
        if (tmp && tmp.length > 0) this.noticeNum = tmp.length
      })
    },
    toShowUsrMenu(){
      this.$parent.$parent.toShowUsrMenu()
    }
  }
}
</script>

<style lang="scss" scoped>
.home-header {
  width: 100vw;
  left: 0px;
  top: 0px;
  height: 1rem;
  line-height: 1rem;
  z-index: 999;
  color: #fff !important;
  padding: 0.2rem 0;
  position: fixed;
  display: flex;
  background-image: url('../../../assets/images/bg.jpg') !important;
  background-repeat: no-repeat;
  background-size: 100vw auto;
  background-color: rgb(000, 000, 000, 0) !important;
  .home-logo {
    float: left;
    img {
      height: 0.75rem;
      width: 2.2rem;
      margin: 0.25rem;
    }
  }
  .home-header-balance {
    border: 1px solid #fff;
    height: 0.75rem;
    margin-top: 0.2rem;
    border-radius: 10px;
    width: calc(100vw - 6rem);
    line-height: 0.75rem;
    position: relative;
    .left {
      width: 0.7rem;
      position: absolute;
      top: 0.1rem;
      left: 0.06rem;
      img {
        width: 0.55rem;
      }
    }
    .right {
      width: 0.7rem;
      position: absolute;
      top: 0.1rem;
      right: 0.06rem;
      img {
        width: 0.55rem;
      }
    }
    .center {
      width: calc(100% - 2rem);
      margin: 0 auto;
      overflow: hidden;
      .balance {
        float: left;
        text-align: right;
        width: calc(100% - 0.1rem);
        overflow: hidden;
      }
    }
  }
  .header-menu {
    position: absolute;
    right: 10px;
    top: 0.4rem;
    width: 2.8rem;
    .item {
      width: 33%;
      float: left;
      text-align: center;
      img {
        width: 75%;
        margin-top: 0.05rem;
        border-radius: 50%;
      }
      img.headimg {
        width: 100%;
        margin-top: -0.1rem;
      }
    }
  }
}
</style>
